'use strict';

module.exports = {
    MS_STANDARD_CLOUD_CONFIG: 'MS_STANDARD_CLOUD_CONFIG',
    STORAGE_SERVER_ROOT_DOWNLOAD: 'STORAGE_SERVER_ROOT_DOWNLOAD',
    STORAGE_SERVER_HEARTBEAT_STATUS: 'STORAGE_SERVER_HEARTBEAT_STATUS',
    STORAGE_SERVER_MESSAGING_SERVICE: 'STORAGE_SERVER_MESSAGING_SERVICE',
    FILE_OPERATIONS_V1: 'FILE_OPERATIONS_V1',
    NO_CLIENT_SOFTWARE: 'NO_CLIENT_SOFTWARE',
    AVAILABILITY: 'AVAILABILITY',
    RESOURCE_CONTROLS: 'RESOURCE_CONTROLS',
    S3_COMPATIBLE_PROXY_TENANCY: 'S3_COMPATIBLE_PROXY_TENANCY'
};